import { useEffect, useState } from "react";
import { AlertTriangle, X } from "lucide-react";

// Listens for `sara:voice` events dispatched by useSpeech. Shows a discreet banner
// only when Sara falls back to the device's built-in browser voice (rare — the free
// Gemini quota is exhausted AND the Edge voice was unreachable).
export function VoiceFallbackBanner() {
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    const onVoice = (e) => {
      const d = e.detail || {};
      if (d.engine === "browser") {
        setMsg("Sara parle avec la voix du navigateur (repli temporaire).");
      } else {
        setMsg(null);
      }
    };
    window.addEventListener("sara:voice", onVoice);
    return () => window.removeEventListener("sara:voice", onVoice);
  }, []);

  if (!msg) return null;

  return (
    <div
      data-testid="voice-fallback-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[80] w-[calc(100%-2rem)] max-w-xl animate-rise"
    >
      <div className="clip-corner border border-[rgba(245,158,11,0.4)] bg-[rgba(20,14,4,0.94)] backdrop-blur-md px-4 py-3 flex items-start gap-3 shadow-[0_0_24px_rgba(245,158,11,0.25)]">
        <AlertTriangle className="h-4 w-4 text-[#f59e0b] shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="text-[12px] text-[#f4e6c8] leading-relaxed">{msg}</p>
        </div>
        <button
          data-testid="voice-fallback-dismiss"
          onClick={() => setMsg(null)}
          className="text-[#8b7a55] hover:text-white shrink-0"
          aria-label="Fermer"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
